import { createSlice } from '@reduxjs/toolkit';

/**
 * Slice for managing sucursales (branches) state in the Redux store.
 * 
 * @constant
 * @name sucursalSlice
 * 
 * @property {string} name - The name of the slice.
 * @property {Object} initialState - The initial state of the slice.
 * @property {Array} initialState.sucursales_list - List of sucursales.
 * @property {Object} initialState.sucursal - Single sucursal object.
 * 
 * @property {Object} reducers - Reducers to handle state changes.
 * @property {Function} reducers.setSucursalListRedux - Sets the list of sucursales.
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @param {Array} action.payload - The new list of sucursales.
 * 
 * @property {Function} reducers.setSucursalRedux - Sets a single sucursal.
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @param {Object} action.payload - The new sucursal object.
 */
export const sucursalSlice = createSlice({
    name: 'sucursales',
    initialState: {
        sucursal: {},
        sucursales_list: [],
        sucursales_list_select: [],
            
    },
    reducers: {
        setSucursalListRedux: ( state, { payload } ) => {
            state.sucursales_list  =  payload;
        },
            setSucursalRedux: ( state, { payload } ) => {
                state.sucursal  =  payload;
        },
        setSucursalesSelectRedux: ( state, { payload } ) => {
            state.sucursales_list_select  =  payload;
        }
    },
    
});


export const { setSucursalListRedux, setSucursalRedux, setSucursalesSelectRedux } = sucursalSlice.actions;